import { useEffect, useState } from "react";

const STORAGE_KEY = "PDFWorkSpace-onboarding-dismissed";

export const useOnboardingTooltip = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = window.localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    window.localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  return { visible, dismiss };
};
